import React from 'react';

const PreviousStructuresModal = () => {
    return (
        <div className="modal fade" id="structures" tabIndex={-1} role="dialog" aria-labelledby="structures" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Previous Structures</h5>
                        <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive Pre_structure">
                            <table className="table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Date/Time</th>
                                        <th scope="col">Vehicle</th>
                                        <th scope="col">Payment Amount</th>
                                        <th scope="col">Net Check</th>
                                        <th scope="col">Update</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>10/31/2022 10:12am</td>
                                        <td>2010 Honda Accord</td>
                                        <td>$435.01</td>
                                        <td>$12,225.00</td>
                                        <td><button className="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Update</button></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td>10/31/2022 10:12am</td>
                                        <td>2010 Honda Accord</td>
                                        <td>$435.01</td>
                                        <td>$12,225.00</td>
                                        <td><button className="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Update</button></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td>10/31/2022 10:12am</td>
                                        <td>2010 Honda Accord</td>
                                        <td>$435.01</td>
                                        <td>$12,225.00</td>
                                        <td><button className="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Update</button></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4</th>
                                        <td>10/31/2022 10:12am</td>
                                        <td>2010 Honda Accord</td>
                                        <td>$435.01</td>
                                        <td>$12,225.00</td>
                                        <td><button className="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Update</button></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">5</th>
                                        <td>10/31/2022 10:12am</td>
                                        <td>2010 Honda Accord</td>
                                        <td>$435.01</td>
                                        <td>$12,225.00</td>
                                        <td><button className="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Update</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer"><button className="btn btn-primary" type="button" data-bs-dismiss="modal">Close</button></div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(PreviousStructuresModal);
